import React, { useState } from "react";
import { createCouponService } from "../../../services/apiService";
import { Card, Input, Button, Form } from "antd";


const ViewRack = () => {
   const [form] = Form.useForm();

  const handleSubmit = (values) => {
    onSearch?.(values);
  };
  return (
     <div style={{ display: "flex", marginTop: 40 }}>
      <Card
        style={{
          width: 350,
          borderRadius: 12,
          boxShadow: "0 4px 14px rgba(0,0,0,0.08)"
        }}
      >
        <Form form={form} layout="vertical" onFinish={handleSubmit}>
          
          <Form.Item
            label="Enter Product Quantity"
            name="qty"
            rules={[{ required: true, message: "Please enter quantity" }]}
          >
            <Input placeholder="Enter Qty / Unit" size="large" />
          </Form.Item>

          <Form.Item
            label="Enter Product ID"
            name="productId"
            rules={[{ required: true, message: "Please enter product id" }]}
          >
            <Input placeholder="Enter ID" size="large" />
          </Form.Item>

          <Button
            type="primary"
            htmlType="submit"
            block
            size="large"
            style={{
              borderRadius: 8,
              marginTop: 10,
              fontWeight: 500
            }}
          >
            Search
          </Button>

        </Form>
      </Card>
    </div>
  );
};

export default ViewRack;
